import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@rockwell-automation-inc/service';

@Component({
  selector: 'px-root',
  standalone: false,
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
      public auth: AuthService,
      public router: Router,
    ) { }
}
